import { GridCellProps, GridColumnProps } from '@progress/kendo-react-grid'
import Tag from 'antd/lib/tag'
import { PaymentProviderMethodDto } from 'api/PaymentProvider/Types/PaymentProviderGroupDto'

export interface GridColumn extends GridColumnProps {
  show: boolean
  width?: number
}

const paymentProvidersUncoveredColumns: GridColumn[] = [
  {
    title: 'PSP Group Name',
    field: 'psp.name',
    cell: (props: GridCellProps): JSX.Element => {
      if (!props?.dataItem?.name) {
        return <td />
      }

      return <td>{props.dataItem.name}</td>
    },
    width: 250,
    show: true,
  },
  {
    title: 'Client Uncovered Card Deposits',
    field: 'psp.uncovered',
    cell: (props: GridCellProps): JSX.Element => {
      if (!props.dataItem.methods) return <td />
      return (
        <td>
          {props.dataItem.methods
            .filter((method: PaymentProviderMethodDto) => method.methodType.name === 'Default')
            .map((method: PaymentProviderMethodDto) => (
              <Tag>{method.paymentProvider.name}</Tag>
            ))}
        </td>
      )
    },
    show: true,
  },
]

export default paymentProvidersUncoveredColumns
